export const GET_BOARDS = "GET_BOARDS";
export const GET_BOARDS_FAILED = "GET_BOARDS_FAILED";
export const GET_BOARDS_REQUEST = "GET_BOARDS_REQUEST";

export const ADD_NEW_BOARD_REQUEST = "ADD_NEW_BOARD_REQUEST";
export const ADD_NEW_BOARD_SUCCESS = "ADD_NEW_BOARD_SUCCESS";
export const ADD_NEW_BOARD_FAILD = "ADD_NEW_BOARD_FAILD";

export const WALLET_VALUE_REQUEST = "WALLET_VALUE_REQUEST";
export const WALLET_VALUE_SUCCESS = "WALLET_VALUE_SUCCESS";
export const WALLET_VALUE_FAILD = "WALLET_VALUE_FAILD";

export const USER_INFO_SUCCESS = "USER_INFO_SUCCESS";

export const GET_TASK_CATEGORIES_PERSONAL = "GET_TASK_CATEGORIES_PERSONAL";

export const USER_PERSONAL_TASKS = "USER_PERSONAL_TASKS";

export const USER_PERSONAL_TASK_UPDATED = "USER_PERSONAL_TASK_UPDATED";

export const USER_PERSONAL_RTLDIR_TASKS = "USER_PERSONAL_RTLDIR_TASKS";

export const SELECTED_FILTERS_PERSONAL_TASKS =
  "SELECTED_FILTERS_PERSONAL_TASKS";

export const GET_USER_NOTIFICATIONS_SUCCESS = "GET_USER_NOTIFICATIONS_SUCCESS";

export const GET_USER_PEYMENTS_SUCCESS = "GET_USER_PEYMENTS_SUCCESS";

export const USER_BOARD_ANSWARE = "USER_BOARD_ANSWARE";

export const USER_AFFILIATE_DATA = "USER_AFFILIATE_DATA";
export const GET_WEEK_TASKS = "GET_WEEK_TASKS";
export const GET_MONTH_TASKS = "GET_MONTH_TASKS";
export const GET_ALL_USER_TASKS = "GET_ALL_USER_TASKS";

export const GET_SITE_CALENDAR = "GET_SITE_CALENDAR";
export const GET_USER_SETTINGS = "GET_USER_SETTINGS";
export const OPEN_RECENT_TASK = "OPEN_RECENT_TASK";
export const USER_PERSONAL_WEEKLY_PLAN = "USER_PERSONAL_WEEKLY_PLAN";

export const FETCH_TETHER_PRICE = 'FETCH_TETHER_PRICE';